<template>

  <div>
    <div
      v-if="!permissions.includes('manage_candidates')"
      class="btn-group">
      <button
        class="btn btn-secondary not-active text-nowrap"
        type="button">
        <span>{{ currentStage ? currentStage.name : '# Sem etapa' }}</span>
      </button>
      <button
        class="btn btn-secondary not-active"
        :class="{'btn-danger': status==='disqualified'}"
        type="button">
        <i class="fas fa-ban" />
      </button>
    </div>

    <div
      v-if="permissions.includes('manage_candidates')"
      class="btn-group"
      :class="{'box-loading': loading}">
      <div class="btn-group">
        <button
          class="btn btn-secondary dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <span>{{ currentStage ? currentStage.name : '# Sem etapa' }}</span>
        </button>
        <div class="dropdown-menu">
          <a 
            class="dropdown-item" 
            href="javascript:void(0)"
            v-for="(stage, index) in jobStages" 
            :key="index"
            @click="changeStage(stage._id)">
            {{ stage.name }}
          </a>
        </div>
      </div>
      <div class="btn-group">
        <button
          class="btn btn-secondary dropdown-toggle"
          :class="{'btn-danger': status==='disqualified'}"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-ban" />
        </button>
        <div
          class="dropdown-menu"
          style="overflow: auto; max-height: 200px;">
          <a
            class="dropdown-item"
            href="javascript:void(0)"
            @click="requalify()"
            v-if="status === 'disqualified'">
              <strong>{{ $t('Requalify') }}</strong>
          </a>
          <a 
            v-if="status === 'qualified'"
            class="dropdown-item" 
            href="javascript:void(0)" 
            v-for="(item, index) in disqualifyReasons" 
            :key="index"
            @click="disqualify(item._id)">
              {{ item.name }}
          </a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'PlacementStatus',
  props: {
    placement_id: {
      type: String
    },
    status: {
      type: String
    },
    stage_id: {
      type: String
    },
    jobStages: {
      type: Array
    }
  },
  components: {
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    disqualifyReasons () {
      return this.$store.getters.getDisqualifyReasons
    },
    stages () {
      return this.$store.getters.getStages
    },
    currentStage () {
      return this.stages.find(item => item._id === this.stage_id)
    }
  },
  created () {
  },
  methods: {
    /*
    changeStage
    */
    changeStage (stageId) {
      this.loading = true

      this.$store.dispatch('movePlacement', {
        _id: this.placement_id,
        stage_id: stageId
      })
      .then((response) => {
        this.$store.dispatch('refreshSelectActivities')
        this.loading = false
        this.$emit('changed')
      })
    },
    /*
    disqualify
    */
    disqualify (disqualifyReasonId) {
      this.loading = true

      this.$store
      .dispatch('disqualifyPlacement', {
        _id: this.placement_id,
        disqualify_reason_id: disqualifyReasonId
      })
      .then((response) => {
        this.$store.dispatch('refreshSelectActivities')
        this.loading = false
        this.$emit('changed')
      })
    },
    /*
    requalify
    */
    requalify () {
      this.loading = true

      this.$store
      .dispatch('requalifyPlacement', {
        _id: this.placement_id
      })
      .then((response) => {
        this.$store.dispatch('refreshSelectActivities')
        this.loading = false
        this.$emit('changed')
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.not-active {
  pointer-events: none;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Placements/CandidatePlacementsStatus.vue